<footer class="wrapper bg-body">
  <div class="section-padding border border-b-0 border-surface bg-header rounded-t-3xl">
    <div class="flex flex-col items-start gap-6 md:flex-row md:justify-between">
      <a routerLink="/" class="shrink-0"
        ><img src="assets/noovi-logo.svg" class="h-10" alt="Logo"
      /></a>
      <ul class="flex flex-col gap-4 text-black md:flex-row md:gap-4">
        <li class="sm:hidden">
          <a
            [routerLink]="['/', AppRoutes.JOIN_PLATFORM]"
            pButton
            [rounded]="true"
            icon="pi pi-send"
            severity="secondary"
          >
            <span pButtonLabel>Join Our Platform</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="[AppRoutes.RESTAURANTS.ROOT]"
            pButton
            [rounded]="true"
            severity="secondary"
            [text]="true"
          >
            <span pButtonLabel>Explore Nearby Eats</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/', AppRoutes.PRIVACY_POLICY]"
            pButton
            [rounded]="true"
            severity="secondary"
            [text]="true"
          >
            <span pButtonLabel>Privacy Policy</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/', AppRoutes.TERMS_AND_CONDITIONS]"
            pButton
            [rounded]="true"
            severity="secondary"
            [text]="true"
          >
            <span pButtonLabel>Terms &amp; Conditions</span>
          </a>
        </li>
      </ul>
    </div>
    <hr class="my-4" />
    <div class="flex justify-center sm:justify-between">
      <span class="text-sm text-muted-color self-center">
        &#169; {{ today | date: 'yyyy' }} Noovi, Inc.
      </span>
      <a
        [routerLink]="['/', AppRoutes.JOIN_PLATFORM]"
        class="hidden sm:inline-flex"
        pButton
        [rounded]="true"
        icon="pi pi-send"
        severity="secondary"
      >
        <span pButtonLabel>Join Our Platform</span>
      </a>
    </div>
  </div>
</footer>
